import { render } from "./RouteVehicle.vue?vue&type=template&id=2f59fb10"
import script from "./RouteVehicle.vue?vue&type=script&lang=js"
export * from "./RouteVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script